<template>
  <div class="faq-article" :class="{open: openState}">
    <div class="faq-article-title" @click="toggle">
      {{article.texts.title}}
    </div>
    <div class="faq-article-content">
      <div v-html="article.texts.body" class="body"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "faq-article",
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      openState: false
    }
  },
  methods: {
    close () {
      this.openState = false;
    },
    toggle () {
      this.openState = !this.openState;
    }
  }
}
</script>

<style scoped>
  .faq-article-title {
    cursor: pointer;
  }
  .body {
    font-family: "Sofia Pro Extra", sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/pages/faq/article.vue